'use strict';

var processInclude = require('base/util');

function hideOutOfStock(){
    var $checkBox = $('button.hide-out-of-stock').find(".fa");
    if(localStorage.getItem('hide-out-of-stock') === 'true'){
        $checkBox.removeClass("fa-square-o");
        $checkBox.addClass("fa-check-square");
        $(".hide-out-of-stock-filter").show();
    }
    else{
        $checkBox.removeClass("fa-check-square");
        $checkBox.addClass("fa-square-o");
        $(".hide-out-of-stock-filter").hide();
    }
    $('button.hide-out-of-stock, .hide-out-of-stock-filter').on("click", function(event){
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        var $checkBox = $('button.hide-out-of-stock').find(".fa");
        if ($checkBox.hasClass("fa-square-o")){
            localStorage.setItem('hide-out-of-stock', true);
            $checkBox.removeClass("fa-square-o");
            $checkBox.addClass("fa-check-square");
            $(".hide-out-of-stock-filter").show();
            getPLPNearbyStores(true);
        }
        else{
            localStorage.setItem('hide-out-of-stock', false);
            $checkBox.removeClass("fa-check-square");
            $checkBox.addClass("fa-square-o");
            $(".hide-out-of-stock-filter").hide();
            getPLPNearbyStores(false);
        }
    });
    $('.refinement-bar button.reset').on("click", function(event){
        localStorage.remoteItem('hide-out-of-stock');
    });
}
function getPLPNearbyStores(checkbox = false){
    var $gridProducts = $('.product-grid div.col-sm-4');
    var pid;
    var getStoreCollectionUrl = "";
    var currProduct;
    var radius;
    var shiptohome;
    var pidArray = [];
    var requestData;
    var outOfStockLabel;
    var nearbyStockLabel;
    var storeId = $('.my-store').data('store-id');
    $gridProducts.each(function(index) {
        currProduct = $($gridProducts[index]).children('.product');
        getStoreCollectionUrl = currProduct.data('findinstorescollection');
        pid = currProduct.data('pid');
        shiptohome = currProduct.data('shiptohome');
        radius = currProduct.data('radius');
        requestData = {
            storeId: storeId,
            radius: radius,
            quantity: 1
        };
        if(!shiptohome){
            pidArray.push(pid);
        }
        else{
            pidArray.push(pid + '-shiptohome');
        }
    });

    requestData.pidArray = JSON.stringify(pidArray);

    $.ajax({
        url: getStoreCollectionUrl,
        data: requestData,
        method: 'GET',
        success: function (response) {
            var hiddenCount = 0;
            $gridProducts.each(function(index) {
                var availability = response.availability[index];

                if(!availability.selectedStore && !availability.nearbyStores && !availability.shipToHomeSelectedStore && !availability.shipToHomeNearbyStores ){
                    hiddenCount++;
                    if(checkbox){
                        $(this).addClass('d-none');
                    }
                    else{
                        $(this).removeClass('d-none');
                    }
                    outOfStockLabel = $(this).find('.out-of-stock-label');
                    ($(outOfStockLabel)).removeClass("d-none");
                }
                else{
                    if (availability.nearbyStores && !availability.selectedStore) {
                        nearbyStockLabel = $(this).find('.in-stock-nearby-label');
                        ($(nearbyStockLabel)).removeClass("d-none");
                    }
                    $(this).removeClass('d-none');
                }

                if (availability.shipToHomeSelectedStore || availability.shipToHomeNearbyStores) 
                {
                    var label = $(this).find('.in-stock-label');
                    ($(label)).removeClass('d-none');
                }
            });
        }
    });
}

$(document).ready(function () {
    // grab the site pref integration object
    var siteIntegrations = require('integrations/integrations/siteIntegrationsUtils');
    var toggleObject = siteIntegrations.getIntegrationSettings();
    if (localStorage.getItem('hide-out-of-stock') == null) {
        localStorage.setItem('hide-out-of-stock', true);
    }
    getPLPNearbyStores(localStorage.getItem('hide-out-of-stock') === 'true');
    $('body').on('search:showMore--success search:filter--success search:sort--success search:updateItemsPerPage--success', () => {
        getPLPNearbyStores(localStorage.getItem('hide-out-of-stock') === 'true');
        if(toggleObject.yotpoCartridgeEnabled && window.yotpo) {
            window.yotpo.refreshWidgets();
        }
        hideOutOfStock();
    });
    processInclude(require('./search/search'));
    hideOutOfStock();
});
